import { render, staticRenderFns } from "./CandidatesPaymentLog.vue?vue&type=template&id=0b802e00&scoped=true&lang=pug&"
import script from "./CandidatesPaymentLog.vue?vue&type=script&lang=js&"
export * from "./CandidatesPaymentLog.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesPaymentLog.vue?vue&type=style&index=0&id=0b802e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b802e00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
